import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState,ListMutations, ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

import FreightForwarderTowingContainerStatistics from './entity'
import Tree from "@/store/shared/entity/tree";

interface FreightForwarderTowingContainerStatisticsState extends ListStateItem<FreightForwarderTowingContainerStatistics>{
    editFreightForwarderTowingContainerStatistics:FreightForwarderTowingContainerStatistics,
    one:Array<FreightForwarderTowingContainerStatistics>;
    two:Array<FreightForwarderTowingContainerStatistics>;
}

class FreightForwarderTowingContainerStatisticsModule extends ListModuleItem<FreightForwarderTowingContainerStatisticsState,any,FreightForwarderTowingContainerStatistics>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editFreightForwarderTowingContainerStatistics:new FreightForwarderTowingContainerStatistics(),
        one:new Array<FreightForwarderTowingContainerStatistics>(),
        two:new Array<FreightForwarderTowingContainerStatistics>(),
    }
    actions={
        async getAll(context:ActionContext<FreightForwarderTowingContainerStatisticsState,any>,payload:any){
            let reponse=await $http.get('services/app/DeclareCustoms/GetFreightForwarderTowingContainerStatistics',{params:payload.data});
            context.state.one=reponse.data.result.freightForwarderTowingContainerStatistics;
            context.state.two=reponse.data.result.totalLogistics;



        },
    };
    overrideMutations={
        edit(state:FreightForwarderTowingContainerStatisticsState,freightforwardertowingcontainerstatistics:FreightForwarderTowingContainerStatistics){
            state.editFreightForwarderTowingContainerStatistics=freightforwardertowingcontainerstatistics;
        }
    }
}
const freightForwarderTowingContainerStatisticsModule=new FreightForwarderTowingContainerStatisticsModule();
export default freightForwarderTowingContainerStatisticsModule;